import styles from './DivPerfil.module.scss';
import { useAuth } from "shared/contexts/Auth/AuthContext";
import { useNavigate } from 'react-router-dom';

export const DivPerfil = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  const handleButtonClick = () => {
    navigate('minhaconta');
  };

  return (
    <div className={styles.page}>
      <div className={styles.menuuser}>
        <button
          onClick={handleButtonClick}
          className={styles.btnuser}
        >
          <img
            src={user?.imageUser || '/imagens/foto.png'}
            alt={user?.name || 'Profile'}
            className={styles.imgUser}
          />
        </button>

        <div className={styles.containerDados}>
          <p className={styles.fraseUser}>Bem-Vindo(a)</p>
          <p className={styles.userName}>
            {user?.name || "Visitante"}
          </p>
        </div>
      </div>
    </div>
  );
};